let _stack = [];

/**
 * Push date to _stack (always last position)
 * @param date {Date|DateTime}
 * @param reset {boolean}
 */
export const add = (date, reset = false) => {
  if (reset) {
    _stack = [];
  }
  _stack.push(date);
};

/**
 * Extract last date and remove it from _stack
 * except for the first entry which stay on _stack
 * @returns {string}
 */
export const pop = () => {
  if (_stack.length === 1) {
    return _stack[0];
  }

  return _stack.pop();
};

/**
 * Return the _stack size (useful to check if we can still rewind)
 * @returns {number}
 */
export const size = () => {
  return _stack.length;
};
